"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonProps = exports.getProps = void 0;

var _router = require("@reach/router");

var getProps = function getProps(_ref) {
  var isCurrent = _ref.isCurrent,
      isPartiallyCurrent = _ref.isPartiallyCurrent;
  if (isCurrent) return {
    style: {
      textDecoration: 'underline'
    }
  };
  if (isPartiallyCurrent) return {
    style: {
      fontWeight: 'bold'
    }
  };
  return {};
};

exports.getProps = getProps;

var getButtonProps = function getButtonProps(item) {
  return item.href ? {
    component: _router.Link,
    to: item.href,
    getProps: getProps
  } : {
    disableRipple: true,
    style: {
      cursor: 'not-allowed'
    }
  };
};

exports.getButtonProps = getButtonProps;